<template>
    <div class="icon-library">
        <transition name="leave-arrive-top">
            <div class="scroll-panel" v-show="icons.length > 0">
                <div class="columns is-multiline is-mobile">
                    <div class="column is-3-mobile is-2-tablet is-1-widescreen" v-for="icon in icons" :key="icon.id" @click="select(icon)">
                        <div class="column-item">
                            <div :class="['icon-container', {'is-active': selectedIcons.includes(icon)}]">
                                <div class="icon-wrap" v-html="icon.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'IconLibrary',

    props: {},

    data() {
        return {
            icons: [],
            selectedIcons: []
        }
    },

    watch: {
        selectedIcons() {
            this.$emit('icon-selected', this.selectedIcons);
        }
    },

    created() {
        let vm = this;
        axios.get('/admin/ajax/svgicons').then(response => {
            vm.icons = response.data;
        }).catch(error => {
            console.log(error);
        });
    },

    methods: {
        clearSelection() {
            this.selectedIcons = [];
        },

        select(icon) {
            if (!this.selectedIcons.includes(icon)) {
                this.selectedIcons = []; // isn't multiselect yet
                this.selectedIcons.push(icon);
            } else {
                this.selectedIcons.splice(this.selectedIcons.indexOf(icon), 1);
            }
        },
    }
}
</script>

<style>

</style>
